import {useNavigate} from "react-router-dom";
import SnackError from "../../components/SnackError";
import React, {useState} from "react";
import {ProfileCreatePayload, useCreateUserMutation} from "./users_api";
import {
    Autocomplete,
    Box,
    Button,
    Card,
    CardActions,
    CardContent,
    createFilterOptions,
    FormControl,
    FormHelperText,
    IconButton,
    InputAdornment,
    InputLabel,
    MenuItem,
    Select,
    TextField,
    Typography
} from "@mui/material";
import Title from "../navigation/Title";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import Visibility from "@mui/icons-material/Visibility";
import * as yup from "yup";
import {useFormik} from "formik";
import {useTranslation} from "react-i18next";
import {PersonApiGet, useGetPersonQuery} from "../people/people_api";

const schema = yup.object().shape({
    email: yup.string().email().required(),
    password: yup.string().required().min(8),
    fullName: yup.string().required(),
    roles: yup.array().of(yup.string().required().oneOf(["Admin", "Worker", "Foreman", "Analytics"])).required(),
    worker: yup.object().nullable()
})

export const UserCreate = () => {


    const navigate = useNavigate();
    const {t} = useTranslation();
    const [reveal, setReveal] = useState<boolean>(false);
    const [createUser, {error, isLoading}] = useCreateUserMutation();
    const {data: workers} = useGetPersonQuery({active: true});

    const formik = useFormik<ProfileCreatePayload>({
        initialValues: {
            email: "",
            password: "",
            fullName: "",
            roles: ["Worker"],
            worker: null,
        },
        onSubmit: async (data, formikHelpers) => {
            const resp = await createUser(data);
            formikHelpers.setSubmitting(false)
            if ("data" in resp) {
                navigate("..")
            }
        },
        validationSchema: schema
    });

    console.log(formik.errors)

    return <Box component={"form"} onSubmit={formik.handleSubmit} className={"form-100"}>
        <Title title={"Nova oseba"}/>
        <Card sx={{mt: "2em"}}>
            <SnackError error={error}/>
            <CardContent>
                <Typography
                    variant="h3"
                >
                    {t("auth.createAccount")}
                </Typography>
                <Typography variant={"body2"}>{t("std.email")}</Typography>
                <TextField
                    name={"email"}
                    id={"email"}
                    placeholder={t("auth.emailPlaceholder")}
                    value={formik.values.email}
                    sx={{width: "100%"}}
                    autoCapitalize="none"
                    autoComplete="email"
                    onChange={formik.handleChange}
                    error={Boolean(formik.errors.email)}
                    helperText={Boolean(formik.errors.email) && formik.errors.email}
                />
                <Typography variant={"body2"}>{t("auth.password")}</Typography>
                <TextField
                    id={"password"}

                    placeholder={t("auth.passwordPlaceholder")}
                    value={formik.values.password}
                    sx={{width: "100%"}}
                    autoCapitalize="none"
                    autoComplete="password"
                    type={reveal ? "text" : "password"}
                    slotProps={{
                        input: {
                            endAdornment: <InputAdornment position="end">
                                <IconButton
                                    aria-label={
                                        reveal ? 'hide the password' : 'display the password'
                                    }
                                    onClick={() => setReveal(!reveal)}
                                    edge="end"
                                >
                                    {reveal ? <VisibilityOff/> : <Visibility/>}
                                </IconButton>
                            </InputAdornment>
                        }
                    }}
                    onBlur={formik.handleBlur}
                    onChange={formik.handleChange}
                    error={Boolean(formik.errors.password)}
                    helperText={Boolean(formik.errors.password) && formik.errors.password}
                />
                <TextField
                    name={"fullName"}
                    id={"fullName"}
                    value={formik.values.fullName}
                    label={"Ime za prikaz"}
                    onBlur={formik.handleBlur}
                    onChange={formik.handleChange}
                    error={formik.touched.fullName && Boolean(formik.errors.fullName)}
                    helperText={formik.touched.fullName && formik.errors.fullName}
                />
                <FormControl fullWidth>
                    <InputLabel id="roles-label">Vloga</InputLabel>
                    <Select
                        labelId="roles-label"
                        id="roles"
                        name={"roles"}
                        value={formik.values.roles}
                        multiple={true}
                        label="Vloga"
                        onChange={formik.handleChange}
                    >
                        <MenuItem value={"Admin"}>Administrator</MenuItem>
                        <MenuItem value={"Foreman"}>Izmenovodja</MenuItem>
                        <MenuItem value={"Worker"}>Delavec</MenuItem>
                        <MenuItem value={"Analytics"}>Analitik</MenuItem>
                        <MenuItem value={"AllRegs"}>Vse odprte registracije</MenuItem>
                    </Select>
                    {Boolean(formik.errors.roles) && <FormHelperText>{formik.errors.roles}</FormHelperText>}
                </FormControl>

                {workers && <Autocomplete
                    id={"defaultWorker"}
                    options={workers}
                    autoSelect={true}
                    value={formik.values.worker}
                    getOptionLabel={(option: PersonApiGet) => {
                        return option.lastName + " " + option.firstName + " (" + option.partnerCode + ")";
                    }}
                    filterOptions={createFilterOptions({
                        stringify: (option) => option.lastName + " " + option.firstName + " " + option.partnerCode,
                    })}
                    onChange={(event, newValue) => {
                        formik.setFieldValue("worker", newValue);
                    }}
                    getOptionKey={(option) => option.documentID}
                    renderInput={(params) => <TextField {...params} label="Privzeti delavec"/>}
                    renderOption={(props, option: PersonApiGet) => {
                        const {key, ...rest} = props
                        return <Box component="li" sx={{'& > img': {mr: 2, flexShrink: 0}}} {...rest} key={key}>
                            {option.lastName} {option.firstName} ({option.partnerCode})
                        </Box>
                    }}
                />}
            </CardContent>
            <CardActions>
                <Button disabled={isLoading || !formik.isValid} type={"submit"}>Shrani</Button>
                <Button onClick={() => navigate("..")}>Prekliči</Button>
            </CardActions>
        </Card>
    </Box>;
}
